const pushToDataLayer = window.BAO.Utils.pushToDataLayer

class BaoProductRecommendationsTabs extends HTMLElement {
  connectedCallback () {
    if (this.bound) return
    this.bound = true

    this.onClick = this.onClick.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)

    this.addEventListener('click', this.onClick)
    this.addEventListener('keydown', this.onKeyDown)

    if (this.dataset.fetchRecommendations === 'true') {
      this.fetchRecommendations()
    }

    this.trackSectionViews()
  }

  disconnectedCallback () {
    this.removeEventListener('click', this.onClick)
    this.removeEventListener('keydown', this.onKeyDown)
  }

  onClick (event) {
    const tab = event.target.closest('[data-recs-tabs-el="tab"]')

    if (tab && this.contains(tab)) {
      event.preventDefault()

      this.trackTabClick(tab)
      this.activateTab(tab.dataset.tab)

      return
    }

    this.trackCardClick(event)
  }

  onKeyDown (event) {
    const tab = event.target.closest('[data-recs-tabs-el="tab"]')
    if (!tab || !this.contains(tab)) return

    const tabs = Array.from(this.querySelectorAll('[data-recs-tabs-el="tab"]'))
    if (tabs.length < 2) return

    const currentIndex = tabs.indexOf(tab)
    let nextIndex = currentIndex

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length
        break
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % tabs.length
        break
      case 'Home':
        nextIndex = 0
        break
      case 'End':
        nextIndex = tabs.length - 1
        break
      default:
        return
    }

    event.preventDefault()
    this.activateTab(tabs[nextIndex].dataset.tab)
    tabs[nextIndex].focus()
  }

  activateTab (tabName) {
    if (!tabName) return

    this.querySelectorAll('[data-recs-tabs-el="tab"]').forEach(tab => {
      const isActive = tab.dataset.tab === tabName
      tab.classList.toggle('is-active', isActive)
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
      tab.tabIndex = isActive ? 0 : -1
    })

    this.querySelectorAll('[data-recs-tabs-el="panel"]').forEach(panel => {
      const isActive = panel.dataset.tab === tabName
      panel.classList.toggle('is-active', isActive)
      panel.hidden = !isActive
    })

    const activePanel = this.querySelector(
      `[data-recs-tabs-el="panel"][data-tab="${tabName}"]`,
    )

    if (!activePanel) return

    activePanel.querySelectorAll('bao-product-carousel').forEach(carouselEl => {
      if (carouselEl.carousel && typeof carouselEl.carousel.update === 'function') {
        carouselEl.carousel.update()
      }
    })
  }

  fetchRecommendations () {
    const apiUrl = this.dataset.url
    if (!apiUrl || apiUrl.includes('product_id=&')) return

    this.classList.add('is-loading')

    fetch(apiUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text
        const section = html.querySelector('bao-product-recommendations-tabs')

        if (!section || !section.innerHTML.trim().length) return

        const currentYmalPanel = this.querySelector('[data-recs-tabs-el="panel"][data-tab="ymal"]')
        const fetchedYmalPanel = section.querySelector('[data-recs-tabs-el="panel"][data-tab="ymal"]')

        if (currentYmalPanel && fetchedYmalPanel) {
          currentYmalPanel.innerHTML = fetchedYmalPanel.innerHTML

          if (currentYmalPanel.querySelector('bao-product-carousel')) {
            this.activateTab('ymal')
          }
        } else {
          this.innerHTML = section.innerHTML
        }

        this.removeAttribute('data-fetch-recommendations')
      })
      .catch(() => {})
      .finally(() => {
        this.classList.remove('is-loading')
      })
  }

  trackSectionViews () {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          pushToDataLayer('prd_recs_tabs_viewed')
          observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0 })

    observer.observe(this)
  }

  trackTabClick (tab) {
    const targetText = tab.textContent.trim()

    pushToDataLayer('prd_recs_tabs_tab_click', {
      target_text: targetText,
    })
  }

  trackCardClick (event) {
    const target = event.target
    const card = target.closest('product-card')
    if (!card || !this.contains(card)) return

    const quickAddOpener = target.closest('quick-add-opener')
    if (quickAddOpener) return

    const panel = card.closest('[data-recs-tabs-el="panel"]')
    const targetContext = panel ? panel.dataset.tab : ''
    const itemTitle = card.dataset.title || ''

    pushToDataLayer('prd_recs_tabs_card_click', {
      item_title: itemTitle,
      target_context: targetContext,
    })
  }
}

if (!customElements.get('bao-product-recommendations-tabs')) {
  customElements.define('bao-product-recommendations-tabs', BaoProductRecommendationsTabs)
}
